import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=74238211"
import script from "../../controllers/notice/notice-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/notice/notice-list.js?vue&type=script&lang=js&external"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=74238211&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports